// @flow
import * as React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import Image from 'components/Image';
import {
  DivCenterMiddle,
} from 'components/Layout';
import {
  LocalizedParagraph,
  useLocalized,
} from 'components/Localized';

type Props = {
  open: boolean,
  onClose: () => void,
};

export default function ModalRotateDevice(props: Props): React.Element<any> {
  const localized = useLocalized();

  return (
    <StyledModal 
      id="modalRotateDeviceRoot"
      isOpen={props.open} 
      contentLabel="Rotate Device Modal"
      overlayClassName="modal-overlay">
      <FillBlack />
      <Wrapper>
        <Image source="./driving-zone/img-guide-logo.png" />
        <LocalizedParagraph {...localized.tutorial_p00_guide_001} />
      </Wrapper>
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  width: ${props => props.theme.layout.width}px;
  height: ${props => props.theme.layout.height}px;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2000;
  background-color: #000000;
  pointer-events: none;

`;

const Wrapper = styled(DivCenterMiddle)`
  flex-direction: column;

  img {
    width: 67px;
    height: 27px;
    padding-bottom: 19px;
  }
`;

const FillBlack = styled.div`
  left: 0px;
  top: 0px;
  width: ${props => props.theme.layout.width * ((window.navigator != null && window.navigator.userAgent != null && window.navigator.userAgent.indexOf("SamsungBrowser") >= 0) ? 1 : 2) }px;
  height: ${props => props.theme.layout.height * ((window.navigator != null && window.navigator.userAgent != null && window.navigator.userAgent.indexOf("SamsungBrowser") >= 0) ? 1 : 2) }px;
  position: absolute;
  background-color: #000000;
  pointer-events: auto;
`;
